"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalSpaceCellComponent = exports.TagContainerStyle = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var ProjectCellComponent_1 = require("./ProjectCellComponent");
exports.TagContainerStyle = {
    paddingLeft: widgets_1.TabStyles.Spacing.SmallSpace,
    fontSize: '10px'
};
function PersonalSpaceCellComponent(props) {
    return (React.createElement("div", { "data-tb-test-id": props.testId || 'personal-space-cell', style: ProjectCellComponent_1.ContainerStyle },
        React.createElement("span", { "data-tb-test-id": 'data-grid-cell-text', title: props.hideTooltips ? undefined : (props.title || props.text) }, props.text),
        React.createElement("span", { "data-tb-test-id": 'data-grid-cell-tag', style: exports.TagContainerStyle }, props.rightTag)));
}
exports.PersonalSpaceCellComponent = PersonalSpaceCellComponent;
//# sourceMappingURL=PersonalSpaceCellComponent.js.map